<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="location-code" class="form-label">Code</label>
              <input type="text" class="form-control" id="location-code" v-model="entity.code"/>
            </div>
            <div class="form-group">
              <label for="location-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="location-name" v-model="entity.name"/>
            </div>
            <div class="form-group">
              <label for="location-country" class="form-label">Country</label>
                <select class="form-control" id="location-country" v-model="entity.country">
                  <option value=""></option>
                  <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
                </select>
            </div>
            <div class="form-group">
              <label for="location-address" class="form-label">Address</label>
              <input type="text" class="form-control" id="location-address" v-model="entity.address"/>
            </div>
            <div class="form-group">
              <label for="location-street" class="form-label">Street</label>
              <input type="text" class="form-control" id="location-street" v-model="entity.street"/>
            </div>
            <div class="form-group">
              <label for="location-state" class="form-label">State</label>
              <input type="text" class="form-control" id="location-state" v-model="entity.subdivision"/>
            </div>
            <div class="form-group">
              <label for="location-county" class="form-label">County</label>
              <input type="text" class="form-control" id="location-county" v-model="entity.county"/>
            </div>
            <div class="form-group">
              <label for="location-cat" class="form-label">Category</label>
                <select class="form-control" id="location-cat" v-model="entity.category">
                  <option value=""></option>
                  <option value="TOWN">Town</option>
                  <option value="PORT">Port</option>
                  <!--
                    <option value="RAILHEAD">Railhead</option>
                    <option value="AIRPORT">Airport</option>
                  -->
                  <option value="ADDRESS">Address</option>
                  <option value="VENDOR_ZONE">Vendor Zone</option>
                </select>
            </div>
            <div class="form-group">
              <label for="location-pc" class="form-label">Post Code</label>
              <input type="text" class="form-control" id="location-pc" v-model="entity.postCode"/>
            </div>
            <div class="form-group">
              <label for="location-alt1" class="form-label">Alternative Name 1</label>
              <input type="text" class="form-control" id="location-alt1" v-model="entity.alternativeName1"/>
            </div>
            <div class="form-group">
              <label for="location-alt2" class="form-label">Alternative Name 2</label>
              <input type="text" class="form-control" id="location-alt2" v-model="entity.alternativeName1"/>
            </div>
            <div class="form-group">
              <label for="location-tz" class="form-label">Time Zone</label>
              <input type="text" class="form-control" id="location-tz" v-model="entity.timeZone"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label class="form-label">Zone</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="Select Zone"
                placeHolder="Type to search"
                :initVal="entity.zone"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="selectZone"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label for="location-pa" class="form-label">Port Area</label>
                <select class="form-control" id="location-pa" v-model="entity.portArea">
                  <option value=""></option>
                  <option v-for="(opt, i) in portAreas" :value="opt.id">{{ opt.name }}</option>
                </select>
            </div>
            <div class="form-group">
              <label for="location-lon" class="form-label">Longitude</label>
              <input type="number" step="0.00000001" class="form-control" id="location-lon" v-model="entity.lon"/>
            </div>
            <div class="form-group">
              <label for="location-lat" class="form-label">Latitude</label>
              <input type="number" step="0.00000001" class="form-control" id="location-lat" v-model="entity.lat"/>
            </div>
            <div class="form-group">
              <label for="location-map" class="form-label">Map Reference</label>
              <input type="text" class="form-control" id="location-map" v-model="entity.mapReference"/>
            </div>
            <div class="form-group">
              <label for="location-gps" class="form-label">GPS Code</label>
              <input type="text" class="form-control" id="location-gps" v-model="entity.gpsCode"/>
            </div>
            <div class="form-group">
              <label for="location-ex-code" class="form-label">External ID</label>
              <input type="text" class="form-control" id="location-ex-code" v-model="entity.externalId"/>
            </div>
            <div class="form-group">
              <label for="maritime" class="form-label">Maritime?</label>
              <div class="material-switch">
                <input id="maritime" type="checkbox" v-model="entity.functionMaritime"/>
                <label for="maritime" class="label-success"></label>
              </div>
            </div>
            <div class="form-group">
              <label for="rd" class="form-label">Road?</label>
              <div class="material-switch">
                <input id="rd" type="checkbox" v-model="entity.functionRoad"/>
                <label for="rd" class="label-success"></label>
              </div>
            </div>
            <div class="form-group">
              <label for="rail" class="form-label">Rail?</label>
              <div class="material-switch">
                <input id="rail" type="checkbox" v-model="entity.functionRail"/>
                <label for="rail" class="label-success"></label>
              </div>
            </div>
            <div class="form-group">
              <label for="air" class="form-label">Air?</label>
              <div class="material-switch">
                <input id="air" type="checkbox" v-model="entity.functionAir"/>
                <label for="air" class="label-success"></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  export default {
    name: 'Location',
    mixins: [AdminEntityMixin, HelperMixin],
    components: {
      Autocomplete
    },
    data () {
      return {
        transformForUpdate: {
          country: this.toMinus,
          zone: this.toMinus,
          worldArea: this.toMinus,
          continent: this.toMinus,
          portArea: this.toMinus,
          lon: this.toZero,
          lat: this.toZero,
          externalId: this.toZero
        },
        newEntityScreen: 'Admin - Locations',
        editEntityScreen: 'Admin - Edit/View Location',
        tab: 'main',
        boxes: [
          {
            prop: 'country',
            id: 'id'
          },
          {
            prop: 'portArea',
            id: 'id'
          }
        ],
        entity: {
          id: null,
          code: null,
          name: null,
          country: null,
          mapReference: null,
          postCode: null,
          gpsCode: null,
          alternativeName1: null,
          alternativeName2: null,
          timeZone: null,
          zone: null,
          address: null,
          street: null,
          state: null,
          county: null,
          category: null,
          worldArea: null,
          continent: null,
          functionMaritime: null,
          functionRail: null,
          functionRoad: null,
          functionAir: null,
          subdivision: null,
          externalId: null,
          portArea: null,
          lon: null,
          lat: null
        },
        entityName: 'location'
      }
    },
    computed: {
      isValid () {
        return this.entity.name && this.entity.name.trim().length > 0
      },
      portAreas () {
        return this.$store.getters['systemOption/portAreas']
      }
    },
    methods: {
      selectZone (z) {
        this.entity.zone = z
        this.locationSearchText = ''
        this.locationSearchResults = []
      },
      getBaseData () {
        return {
          id: null,
          code: null,
          name: null,
          country: null,
          mapReference: null,
          postCode: null,
          gpsCode: null,
          alternativeName1: null,
          alternativeName2: null,
          timeZone: null,
          zone: null,
          address: null,
          street: null,
          state: null,
          county: null,
          category: null,
          worldArea: null,
          continent: null,
          functionMaritime: null,
          functionRail: null,
          functionRoad: null,
          functionAir: null,
          subdivision: null,
          externalId: null,
          portArea: null,
          lon: null,
          lat: null
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// Location.vue?3763bbc9